exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#result-list{\n  z-index: 99999;\n  position: absolute;\n  margin-top: 0;\n  max-height: 200px;\n  overflow-y: auto\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/country-autocomplete/country-autocomplete.component.css
// module id = ../../../../../src/app/_components/country-autocomplete/country-autocomplete.component.css
// module chunks = main